export interface TViewedItemsActivity {
  asking_discount?: number
  asking_price: number
  asking_price_per_carat?: number
  category_id: number
  company_id: number
  company_title: string
  consignor_name: string
  consignor_payout_amount: number
  cost: string
  count_of_bids: number
  count_of_unique_user_views: number
  email: string
  high_bid: number
  item_id: number
  list_price: number
  resolved: boolean
  sales_target: number
  sales_target_per_carat?: number
  shipping_owner: string
  stock_number: string
  title: string
  user_id: number
  weight?: number
  winning_bid: number
  buy_bid?: number
}

export interface TViewedItemsActivityChild {
  company_id: number
  company_title: string
  count_views: number
  disable_email_notifications: boolean
  disabled: boolean
  email: string
  first_name: string
  full_access_categories: number[]
  last_name: string
  last_signed_in: string
  message_method_id: number
  message_title: string
  role_id: number
  source: string
  user_id: number
  view_only_categories: number[]
  worthy_buyer_id: number
}

export interface IGetViewedItemsActivityChild {
  users: TViewedItemsActivityChild[]
}

export interface TViewedItemsActivityMessage {
  message: string
}

export interface TViewedItemsActivityState {
  loading: boolean
  data: TViewedItemsActivity[] | null
  errors?: string | undefined
  childData: Map<number, TViewedItemsActivityChild[]> | null
}

export enum ActionTypes {
  GET_VIEWED_ITEM_ACTIVITY_R = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_R',
  GET_VIEWED_ITEM_ACTIVITY_S = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_S',
  GET_VIEWED_ITEM_ACTIVITY_WITH_O_OFFSET_S = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_WITH_O_OFFSET_S',
  GET_VIEWED_ITEM_ACTIVITY_E = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_E',

  GET_VIEWED_ITEM_ACTIVITY_CHILD_R = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_CHILD_R',
  GET_VIEWED_ITEM_ACTIVITY_CHILD_S = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_CHILD_S',
  GET_VIEWED_ITEM_ACTIVITY_CHILD_E = '@@TENDERS/GET_VIEWED_ITEM_ACTIVITY_CHILD_E',
}
